//exclusive
export const EXCLUSIVE_IMAGES_PER_PAGE = 8;

//image-gallery
export const NAVIGATION_TABS = [
  { id: "exterior", label: "Exterior" },
  { id: "interior", label: "Interior" },
  { id: "safety", label: "Safety" },
  { id: "tech", label: "Tech" },
  { id: "videos", label: "Videos" },
  { id: "360", label: "360° View" },
] as const;

export const SUB_TABS = [
  { id: "sunroof", label: "Sunroof" },
  { id: "headlight", label: "Headlight" },
  { id: "taillamp", label: "Taillamp" },
  { id: "topview", label: "Top view" },
  { id: "dashboard", label: "Dashboard" },
  { id: "powersteering", label: "Power Steering" },
  { id: "airbags", label: "Airbags" },
  { id: "automaticmusic", label: "Automatic Music" },
  { id: "amtwipr", label: "Automatic Wiper" },
] as const;

export const IMAGES_PER_PAGE = 6;
export const GRID_PATTERN = [1, 2, 1, 2];
export const INITIAL_VARIANTS_COUNT = 6;

//varient-view
